import * as Sentry from "@sentry/react";
import { IconBug } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Icon } from "#shared/icons/Icon";
import { Alert } from "#shared/view/components/Alert";
import { Container } from "#shared/view/components/Container";
import { Group } from "#shared/view/components/Group";
import { Space } from "#shared/view/components/Space";
import { Text } from "#shared/view/components/Text";
import { Button } from "#shared/view/designSystem/Button";

export type ErrorDisplayProps = {
  error?: unknown;
  resetError?: () => void;
  resetErrorTitle: string;
};

export function ErrorDisplay({ error, resetError, resetErrorTitle }: ErrorDisplayProps) {
  const { t } = useTranslation();
  const canShowReportDialog =
    typeof Sentry.showReportDialog === "function" && typeof Sentry.lastEventId === "function";

  const handleReport = () => {
    if (!canShowReportDialog) {
      return;
    }

    const lastEventId = Sentry.lastEventId();
    Sentry.showReportDialog(lastEventId ? { eventId: lastEventId } : undefined);
  };

  return (
    <Container p="xl">
      <Alert
        variant="light"
        color="red"
        icon={<IconBug size={16} />}
        title={t("errors.errorOccurred")}
      >
        <Text>{t("errors.errorReported")}</Text>
        <Space h="sm" />
        <Text>
          {t("errors.errorDetails")} : {String(error)}
        </Text>
      </Alert>

      <Space h="md" />

      <Group>
        {resetError && resetErrorTitle && (
          <Button onClick={resetError} leftSection={<Icon name="arrowLeft" size={16} />}>
            {resetErrorTitle}
          </Button>
        )}
        {canShowReportDialog && (
          <Button variant="outline" onClick={handleReport}>
            {t("errors.contactSupportDetails")}
          </Button>
        )}
      </Group>
    </Container>
  );
}
